module.exports = __webpack_public_path__ + "static/q7-00270ab4da6ba32df6c1ff6f18d6313e.svg";